import * as React from 'react';

function SvgListOutline(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" {...props}>
      <path d="M26 30H6V2h20zM8 28h16V4H8z" />
      <path d="M15 8h6v2h-6zM11 8h2v2h-2zM15 15h6v2h-6zM11 15h2v2h-2zM15 22h6v2h-6zM11 22h2v2h-2z" />
    </svg>
  );
}

export default SvgListOutline;
